import styled from 'styled-components';

const MQCard = styled.div`
    display: inline-block;
    width: 80px;
    margin: 5px;
    height: 60px;
    border: solid 1px #9E9E9E;
    border-radius: 5px;
    background: ${({ active }) => active ? '#7E99CD' : 'white'};
    color:${({ active })=>active ? 'white':'gray'};
    transform:${({ active }) => active ? 'scale(1.1)' : 'unset'};
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    span{
        position: relative;
        left: 5px;
        font-size: 11px;
        color:${({ active })=>active ? 'white':'gray'};
        pre{
            margin:0px;
        }
    }
`
export default MQCard;